module.exports = __webpack_public_path__ + "img/step_confirm.0542bb86.svg";